import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const UniversityTeachers = ({owner}) => {
  // console.log("The owner is:",owner)
  const  {id,university_name,dean_name,department_name} = useParams()
  const finalId = owner === "dean" ? id ?? "" : "";
  const navigate = useNavigate();
  const [teachers, setTeachers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  // console.log("The teachers are:",teachers)
  const fetchTeachers = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/teacher/university/teacher/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );
      setTeachers(res?.data || []);
    } catch (error) {
      console.log("Error while getting profiles", error);
      setTeachers([]);
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, []);

  // Filter departments by department name or dean name
  const filteredTeachers = teachers.filter((dept) => {
    const deptName = dept?.user?.name?.toLowerCase() || "";
    // const deanName = dept?.dean?.profile_data?.name?.toLowerCase() || "";
    const search = searchTerm.toLowerCase();

    return deptName.includes(search)
  });

  // Delete department by id (frontend only)
 const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this teacher?")) {
    return;
  }

  try {
    await axios.delete(`${BASE_URL}/teacher/${id}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "x-api-key": process.env.REACT_APP_X_API_KEY,
      },
    });
    alert("Teacher deleted successfully");
   fetchTeachers()
  } catch (error) {
    console.error("Error deleting teacher:", error.response || error);
    alert("Failed to delete teacher");
  }
};


  return (
    <div className="p-6">
  <div className="flex items-center gap-3 mb-4">
    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    </div>
    <div>
      <h1 className="text-2xl font-bold text-gray-900">University Teachers</h1>
      <p className="text-sm text-gray-500 mt-1">Below is a list of all teachers in the university.</p>
    </div>
  </div>

  <div className="flex justify-between items-center mb-6">
    <div className="relative w-full md:w-1/3">
      <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <input
        type="text"
        placeholder="Search by teacher name..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    <button
      onClick={() => navigate(owner === 'dean' ? `/marketplace/${finalId}/dean/teacher/add` : owner ==='labhead' ? `/marketplace/${university_name}/${dean_name}/${department_name}/lab/labhead/teacher/add` : "/marketplace/university/teacher/add")}
      className="flex items-center gap-2 px-4 py-2 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
      </svg>
      Add Teacher
    </button>
  </div>

  <div className="border border-gray-200 rounded-xl overflow-hidden">
    <table className="min-w-full">
      <thead className="bg-gray-50 border-b border-gray-200">
        <tr>
          <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Profile</th>
          <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Name</th>
          <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Email</th>
          <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Created By</th>
          <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Actions</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {filteredTeachers.length > 0 ? (
          filteredTeachers.map((teacher) => (
            <tr key={teacher.id} className="hover:bg-gray-50 transition-colors">
               <td className="px-6 py-4">
              <div className="relative w-10 h-10">
                <img
                  src={teacher?.user?.profile_image}
                  alt={teacher?.user?.name}
                  className="w-10 h-10 rounded-xl object-cover border border-gray-200"
                />
                <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
              </div>
            </td>
              <td className="px-6 py-4 text-sm text-gray-900">{teacher?.user?.name}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{teacher?.user?.email}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{
  (owner === "admin" || owner === "dean" || owner === "labhead")
    ? teacher?.dean ? "Dean" : teacher?.labhead ? "Labhead" : "Admin"
    : ""
}</td>
              <td className="px-6 py-4">
                <div className="flex gap-2">
                  <button
                    onClick={() => handleDelete(teacher.id)}
                    className="flex items-center gap-1 px-3 py-1.5 bg-red-100 text-red-600 text-sm font-medium rounded-lg hover:bg-red-200 transition-colors"
                  >
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="3" className="px-6 py-12 text-center">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <p className="text-gray-500">No departments found.</p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>
  );
};

export default UniversityTeachers;
